import React from 'react'

export interface TableData {
	content: string[][]
	stretched: boolean
	withHeadings: boolean
}

export interface BEditorJsTableProps {
	data: TableData
}

export const BEditorJsTable: React.FC<BEditorJsTableProps> = ({ data }) => {
	const { content, stretched, withHeadings } = data

	if (!content || !content.length) {
		return null
	}

	return (
		<div className='editorjs-renderer_block my-6'>
			<div className={`overflow-x-auto ${stretched ? 'w-full' : ''}`}>
				<table className='min-w-full border-collapse text-[#4A337A] rounded-lg overflow-hidden'>
					{withHeadings && content.length > 0 && (
						<thead>
							<tr className='bg-[#F3F4F6]'>
								{content[0].map((cell, cellIndex) => (
									<th
										key={cellIndex}
										className='border border-[#8061CD] px-4 py-2 text-left font-medium'
									>
										{cell}
									</th>
								))}
							</tr>
						</thead>
					)}
					<tbody>
						{content.map((row, rowIndex) => {
							// Skip the first row if it's a header
							if (withHeadings && rowIndex === 0) {
								return null
							}

							return (
								<tr
									key={rowIndex}
									className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-[#DED3B9]'}
								>
									{row.map((cell, cellIndex) => (
										<td key={cellIndex} className='px-4 py-2 text-sm'>
											{cell}
										</td>
									))}
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		</div>
	)
}

export default BEditorJsTable
